import React from 'react';
import type { CSSProperties } from 'react';
import {
  PROPOSAL_BUNDLE_STATE,
  PROPOSAL_BUNDLE_STATE_LABELS,
  type ProposalBundleState
} from '../../types/proposalBundles';

type Props = {
  state: ProposalBundleState;
  style: CSSProperties;
};

const getStateColor = (state: ProposalBundleState): string => {
  switch (state) {
    case PROPOSAL_BUNDLE_STATE.SUGGESTING:
      return '#d4a60d';
    case PROPOSAL_BUNDLE_STATE.SELECTED:
      return '#4a9464';
    case PROPOSAL_BUNDLE_STATE.REJECTED:
      return '#888888';
    default:
      return '#666';
  }
};

const StateLabel = ({ state, style }: Props) => {
  const stateText = PROPOSAL_BUNDLE_STATE_LABELS[state] ?? state;
  const stateColor = getStateColor(state);
  return <span style={{ ...style, color: stateColor }}>{stateText}</span>;
};

export default StateLabel;
